import styled, { css } from "styled-components";
import { Box, Button, Stack, SvgIcon } from "@mui/material";
import { lightBlue2 } from "styles/theme";
import { lightPrimary } from "styles/theme";
import { Header as HeaderDataGrid } from 'components/DataGrid/Style'
import { styled as muiStyled } from '@mui/material/styles';
import { Scroll, ScrollCss } from "styles/GlobalCss";
import { bg } from "styles/theme";
import { thirdly4 } from "styles/theme";
import { thirdly2 } from "styles/theme";
import { ratingColors, ratingText } from "keys/rating";
import { lightSecondary } from "styles/theme";
import { secondary } from "styles/theme";
import { dark } from "styles/theme";
import { sidebar } from "styles/theme";
import { height } from "@mui/system";



export const BarChartStyles = muiStyled(Box)(({ size }) => ({
    height: "100%",
    overflow: "auto",
    '.point-icon': {
        position: "relative",
        left: 130,
        bottom: 17
    },
    '.auto-complete-fields': {
        display: "flex",
        columnGap: 10
    },
    '.placeholder-title': {
        fontWeight: "bold",
        fontSize: 23,
    },
    '.bar-chart-placeholder': {
        width: 500,
        height: 250,
        display: "flex",
        justifyContent: "center",
        opacity: 0.5,
    },
    '.placeholder': {
        padding: 20,
        width: 800,
        background: "white",
        borderRadius: 15,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    },
    '.wrap-placeholder': {
        paddingTop: 30,
        display: "flex",
        flexDirection: "column",
        rowGap: 30,
        justifyContent: "center",
        alignItems: "center"
    },
    '.bar-title': {
        height: 40,
        display: "flex",
        alignItems: "center",
    },
    '.test-type': {
        width: 200
    },
    '.bar-section': {
        marginTop: 4,
        padding: 15,
        boxSizing: "border-box",
        background: "white",
        borderRadius: 10
    }
}));

export const ReadingComprehensionCellStyles = muiStyled(Box)(({ size }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    '.mark-chip': {
        width: 37
    }
}));


export const ProfileCellStyles = muiStyled(Box)(({ batteryHidden, wcpm_foundational_index, wcpm_fluency_index, factored_percent_accuracy_fluency_avg_rating_index, wpm_fluency_avg_rating_index, size }) => ({
    flexDirection: "column",
    lineHeight: 1.2,
    rowGap: 1,
    '.correct-words-summary': {
        fontWeight: "bold"
    },
    '.words-per-minute': {
        color: batteryHidden || ratingText[wpm_fluency_avg_rating_index - 1]
    },
    '.percent-accuracy': {
        color: batteryHidden || ratingText[factored_percent_accuracy_fluency_avg_rating_index - 1]
    },
    '.wcpm-fluency': {
        color: batteryHidden || ratingText[wcpm_fluency_index - 1]
    },
    '.wcpm_foundational': {
        color: batteryHidden || ratingText[wcpm_foundational_index - 1]
    }
}))

export const WarningHeaderStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
}))


export const MultipleChoiceCellStyles = muiStyled(Box)(({ size }) => ({
    position: "relative",
    right: 33,
    display: "flex",
    justifyContent: "center"
}));

export const CellWithButtonStyles = muiStyled(Box)(({ size }) => ({
    position: "relative",
    right: 33,
    display: "flex",
    justifyContent: "center"
}));

export const CreateBatteryStyles = muiStyled(Box)(({ size }) => ({
    paddingTop: 20,
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    alignItems: "center",
    width: "100%",
    '.select-battery': {
        width: 320
    }
}));

// נוסיף את ה-Styled Components החדשים הללו לאזור העיצובים שלך
export const ScrollableArea = muiStyled(Box)({
    flex: 1,           // יתפוס את כל הגובה הפנוי
    overflowY: 'auto', // יגרום לגלילה לקרות רק כאן
    paddingRight: '4px', // מרווח קטן אם צריך
});

export const PaginationArea = muiStyled(Box)({
    flexShrink: 0,      // מונע מהאזור הזה להתכווץ
    borderTop: '1px solid #E8EEF6',
});

export const SummaryTableStyles = muiStyled(Box)({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "auto",
    '.header': {
        height: 70,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    }
});

export const StudentProgressStyles = muiStyled(Stack, {
    shouldForwardProp: (prop) => prop !== 'columns'
})(({ theme, columns }) => ({
    overflow: "auto",
    // עיצוב הכרטיס
    '.student-card': {
        borderRadius: theme.shape.borderRadius * 2,
        overflow: 'hidden',
    },

    // עיצוב הגריד
    '.grid-container': {
        display: 'grid',
        gridTemplateColumns: `minmax(180px, 1.5fr) repeat(${columns}, minmax(60px, 1fr)) minmax(220px, 2fr)`,
        borderTop: `1px solid #E8EEF6`,
        borderRight: `1px solid #E8EEF6`,

        // הגדרות בסיס לכל התאים
        '& > div': {
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(1.5),
            minHeight: '48px',
            borderBottom: `1px solid #E8EEF6`,
            borderLeft: `1px solid #E8EEF6`,
        }
    },

    // עזרי פריסה
    '.cell-start': { justifyContent: 'flex-start' },
    '.cell-center': { justifyContent: 'center' },
    '.cell-between': { justifyContent: 'space-between' },

    // טקסטים וכותרות
    '.header-cell': { fontWeight: 'bold', textAlign: 'center' },
    '.subheader-cell': { color: '#7E92A2', fontSize: '14px' },
    '.metric-name': { fontWeight: '500' },

    // אזור המלצות
    '.recommendation-box': {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: theme.spacing(2)
    },
    '.recommendation-field': {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#F9FAFC',
            '& fieldset': { borderColor: '#E8EEF6' },
        }
    },
    // ==========================================
    // קסם ההדפסה: הגדרות קשיחות למדפסת!
    // ==========================================
    '@media print': {
        '.student-card': {
            pageBreakInside: 'avoid', // מונע חיתוך כרטיס תלמיד באמצע דף
            marginBottom: '20px',
            width: '100%',
        },
        '.grid-container': {
            display: 'grid !important', // מכריח את הדפדפן לשמור על הגריד
            width: '100%',
            borderTop: '1px solid #E8EEF6 !important',
            borderRight: '1px solid #E8EEF6 !important',
        },
        '.grid-container > div': {
            borderBottom: '1px solid #E8EEF6 !important',
            borderLeft: '1px solid #E8EEF6 !important',
            backgroundColor: '#ffffff !important',
        },
        // העלמת אלמנטים מיותרים בהדפסה
        'button, .MuiButtonBase-root': {
            display: 'none !important'
        },
        // ביטול מסגרת של תיבת הטקסט בהדפסה כדי שייראה כמו טקסט רגיל
        '.recommendation-field fieldset': {
            border: 'none !important',
        },
        '.recommendation-field textarea': {
            resize: 'none',
        }
    }
}));

export const PerformBatteryHeaderStyles = muiStyled(Box)(({ size }) => ({
    display: "flex",
    alignItems: "center",
    columnGap: 7
}));

export const StepCellStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    columnGap: 4,
    '.assessment-items': {
        width: "auto",
        display: "flex",
        columnGap: 5,
        alignItems: "center",
    },
    '.wrap-expand-icon': {
        cursor: "pointer",
        ":hover": {
            opacity: 0.7
        },
        position: "relative",
        display: "flex",
        justifyContent: "center",
        width: "30px",
    },
    ".expand-btn": {
        display: "none !important",
        position: "absolute",
    },
    ".assessment-items:hover .expand-btn": {
        display: "flex !important",
        position: "relative",
    },
    '.circle-item': {
        height: 22,
        borderRadius: 30,
        width: 3,
    }
}));

export const StepStyles = muiStyled(Box)(({ index }) => ({
    border: `2px solid black`,
    borderColor: index ? ratingColors[index - 1] : "#CAD3DF",
    // borderColor: index == -1 && "black",
    background:
        index >= 0 &&
            // למקרה שהמבדק בוצע אך לא נבדק
            index == 0 ?
            "#CAD3DF" :
            ratingColors[index - 1]
    ,
    borderRadius: 30,
    ":hover": {
        opacity: 0.7,
    }
}));

export const AssessmentsStyles = muiStyled(Box)(({ size }) => ({
    height: "100%",
    overflow: "auto",
    '.wrap-tab-header': {
        display: "flex",
        justifyContent: "space-between"
    },
    '.btn-actions': {
        display: "flex",
        columnGap: 5,
        alignItems: "center"
    },
    '.wrap-table': {
        flexGrow: 1,
        overflow: "auto"
    },
    '.assessment-tabs-and-table': {
        flexGrow: 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column"
    },
    '.wrap-placeholder-content': {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    },
    '.placeholder-img': {
        width: 600,
        height: 280
    },
    '.ability-group': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.ability-groups': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15
    },
    '.ability-group-header': {
        display: "flex",
        columnGap: 10,
        fontSize: 18,
        fontWeight: "bold",
        alignItems: "center"
    }
}));

export const ProfileStyles = muiStyled(Box)(({ size }) => ({
    height: "100%",

    '.point-icon': {
        position: "relative",
        bottom: 20,
        left: 130
    },
    '.profiles-img': {
        width: 600,
        height: 370
    },
    '.test-type': {
        display: "flex",
        flexDirection: "column"
    },
    '.profiles-header': {
        display: "flex",
        flexDirection: "column",
        rowGap: 15,
    },
    '.placeholder-title': {
        fontWeight: "bold",
        fontSize: 20,
        marginBottom: 25
    },
    '.placeholder': {
        background: "white",
        padding: 20,
        borderRadius: 15,
        width: 800,
        display: "flex",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: 23,
    },
    '.wrap-placeholder': {
        alignItems: "center",
        paddingTop: 30,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
    },
    '.placeholder-sub-title': {

    }
}));

export const ProfileCardHeaderStyles = muiStyled(Box)(({ height }) => ({
    height: height
}));

export const ProfileCardStyles = muiStyled(Box)(({ height }) => ({
    height: height,
    border: `1px solid ${thirdly2}`,
    borderRadius: 8,
    width: 400,
    background: "white",
    padding: "15px 18px",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
}));

export const SvgIconStyles = muiStyled(SvgIcon)(({ size }) => ({
    fill: "transparent",
}));


export const AssessmentProfilesStyles = muiStyled(Box)(({ size }) => ({
    flexGrow: 1,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    marginTop: 30,
    '.profile-items': {
        display: "flex",
        columnGap: 10
    },
    '.profile-item': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20,
        background: thirdly4,
        borderRadius: 15,
        padding: "13px 15px 15px 15px",
        boxSizing: "border-box"
    },
    '.wrap-expand-header': {
        display: "flex",
        columnGap: 5
    },
    '.profile-card-header': {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    '.MuiPaper-root.MuiAccordion-root': {
        background: "white",
        width: "450px",
        borderRadius: 8,
    },
    '.MuiButtonBase-root.MuiAccordionSummary-root': {
        height: 70
    },
    '.test-taker-item': {
        padding: 5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    '.profile-item-name': {
        display: "flex",
        columnGap: 7,
        alignItems: "center"
    },
    '.MuiAccordionSummary-content': {
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 10px 0px 0px",
    },

    '.test-taker-list-title': {
        display: "flex",
        alignItems: "center"
    },
    '.profile-loading': {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%"
    },
    '.profile-name': {
        display: "flex",
        columnGap: 6
    },
    '.wrap-chip': {
        display: "flex",
        alignItems: "center"
    },
    '.test-taker-list': {
        overflow: "auto",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 10
    },
    '.profile-cards': {
        display: "flex",
        columnGap: 40,
        flexWrap: "wrap",
        rowGap: 20,
        overflow: "auto",
        justifyContent: "center",
        ...ScrollCss
    },
    '.MuiAccordionDetails-root': {
        height: 400,
    },
    '.profile-card': {
        border: `1px solid ${thirdly2}`,
        borderRadius: 15,
        width: 400,
        background: "white",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 20,
    }
}));

export const headercss = css`
grid-template-columns:  120px 120px 120px 100px auto 130px 130px;
`

export const WrapBasicButton = styled(Button)`
box-shadow: none !important;
border:1px solid ${lightPrimary} !important;
`

export const WrapFullButton = styled(Button)`
box-shadow: none !important;
border:1px solid ${lightBlue2} !important;
`

export const IndicationLabel = styled.div`
color:${props => props.color};
`

export const WrapIndication = styled.div`
// width: ${props => props.size === "sm" ? `25px` : `35px`};
.MuiSvgIcon{
    color:pink !important
}
`

export const TableToolbarStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    flexGrow: 1,
    justifyContent: "end",
    alignItems: "center",
    columnGap: "22px",
    marginRight: 40,
    '.default-view': {
        color: "#26445A80",
        textDecoration: "underline"
    },
    '.view-types': {
        border: `1px solid ${bg}`,
        background: thirdly4,
        padding: 6,
        display: "flex",
        columnGap: 10,
        borderRadius: 10
    }
}));


export const WrapViewTypes = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: "4px 0",
}));

export const DoughnutChartsStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    rowGap: 20,
    '.assessment-count': {
        height: 40,
        marginTop: 5,
        display: "flex",
    },
    '.chart-card': {
        border: `1px solid ${thirdly2}`,
        borderRadius: 15,
        width: 300,
        background: "white",
        height: 600,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        rowGap: 20,
    },
    '.chart-cards': {
        display: "flex",
        columnGap: 40,
        flexWrap: "wrap",
        rowGap: 20,
        flexGrow: 1,
        overflow: "auto",
        ...ScrollCss
    },
    '.chart-list-square': {
        width: 15,
        height: 15,
    },
    '.chart-list': {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        rowGap: 20,
        padding: "0px 35px",
        boxSizing: "border-box"
    },
    '.chart-list-item': {
        display: "flex",
        columnGap: 10,
        alignItems: "center"
    },
    '.card-content': {
        display: "flex",
        flexDirection: "column",
        rowGap: 40,
        alignItems: "center"
    },
    '.doughnut-chart': {
        height: 250,
        width: 250
    },
    '.card-header': {
        display: "flex",
    },
    '.card-label': {
        background: thirdly4,
        border: `1px solid ${thirdly2}`,
        borderRadius: 5,
        padding: "6px 12px"
    }
}));

export const RateAndAccuracyHeaderStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    columnGap: "10px",
    '.tooltip': {
        position: "relative",
        bottom: 10,
        right: 10,
        width: 3
    },
    '.cell-with-icon': {
        textWrap: "nowrap",
        lineHeight: 1.2,
        [theme.breakpoints.down('md')]: {
            width: "auto"
        }
    }
}));

export const AssessmentCategoryCellStyles = muiStyled(Box)(({ theme, $systemUI }) => ({
    display: "flex",
    columnGap: 10,
    alignItems: "center",
    whiteSpace: "nowrap",
    ".MuiSvgIcon-root": {
        fill: "transparent !important"
    }
}));


export const ProsodyCellStyles = muiStyled(Box)(({ color }) => ({
    color: color
}));

export const Header = styled(HeaderDataGrid)`
width:100%;
display: flex;
align-items: center;
column-gap: 6px;
overflow-y:hidden;
overflow-x:auto;
row-gap: 10px;
justify-content: flex-start;
padding:15px 0px;
.pill-label{
    white-space: nowrap;
    font-size: 15px;
    color: ${dark};
}
.header-divider{
    height: 24px;
    border-color: #404F69;
    margin: 0px 4px;
}
${props => props.headercss && props.headercss};
${Scroll};
`

export const WrapFiltersHeader = styled.div`
display:flex;
align-items:center;
height:${props => props.height ? `${props.height}px` : "70px"};
`

export const WrapFiltersHeaderColumn = styled.div`
display:flex;
flex-direction:column;
row-gap:8px;
.description-row{
    font-size: 15px;
    color: ${dark};
}
`
